import { EditableSiteType, SiteType } from '@features/sites/sitesAPI';

export default function getSiteNameAndLocation(
  site: SiteType | EditableSiteType,
) {
  return `${site.store_name} - ${site.store_city}, ${site.store_state}`;
}
